// Checkout Forms
import { FIRST_NAME_DATA_STANDARDS, LAST_NAME_DATA_STANDARDS } from 'checkout-forms/form/fields';
import getAddressFieldsConfig from 'checkout-forms/form/configs/address';

// Config
import { countryCodeIsInternational } from '@utils/address/addressHelpers';
import makePostcodeOptional from '@utils/address/makePostcodeOptional';
import getInternationalPhoneNumberConfig from '@utils/lazy/internationalPhoneNumberConfig';

export const GOOGLE_PAY_BILLING_ADDRESS_FORM_ID = 'googlePayBillingDetailsForm';
export default function getGooglePayBillingDetailsFormConfig(params) {
  const {
    countryCode,
    addressLines = 3,
    maxAddressLines,
    actions,
    configExtras,
    international,
    isSimplePhoneNumberFeatureActive,
    enableGBCounty,
  } = params;

  const { isClickCollectOrder, submitButtonExtra } = configExtras;

  const ADDRESS_FIELDS = getAddressFieldsConfig({
    international,
    countryCode,
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
    allowAsciiOnly: true,
    enableGBCounty,
  });

  const PHONE_NUMBER = getInternationalPhoneNumberConfig({
    isClickCollectOrder,
    isSimplePhoneNumberFeatureActive,
    showDefaultInstruction: true,
  });

  const postcodeOptional = countryCodeIsInternational(countryCode);
  if (postcodeOptional) {
    makePostcodeOptional(ADDRESS_FIELDS);
  }

  return {
    submitButton: 'Continue with payment',
    submitButtonExtra,
    id: GOOGLE_PAY_BILLING_ADDRESS_FORM_ID,
    fields: [FIRST_NAME_DATA_STANDARDS, LAST_NAME_DATA_STANDARDS, PHONE_NUMBER, ...ADDRESS_FIELDS],
  };
}
